import { HeapCustomEvent } from 'config';
import type { ValidationRule } from './Cart';

enum AlertType {
  INFO = 'info',
  ERROR = 'error',
}

interface IAlert {
  type: AlertType;
  validationRule?: ValidationRule;
  heapEvent?: HeapCustomEvent;
  message?: string;
}

/**
 * Alerts contain information about:
 *
 * @param type           Can be errors (in that case, cart cannot be saved)
 *                       or just informational.
 *
 * @param validationRule The rule that caused it. It can be null If it comes
 *                       from another source, e.g., it was sent by the BE and
 *                       it's not the result of a broken FE rule).
 *
 * @param heapEvent      The associated HeapCustomEvent. Can be null, no
 *                       every alert triggers a Heap event.
 *
 * @param message        Null for Alerts with a validationRule, as those
 *                       have associated FE components and no message.
 */
class Alert implements IAlert {
  type: AlertType;
  validationRule?: ValidationRule;
  heapEvent?: HeapCustomEvent;
  message?: string;

  constructor(
    type: AlertType,
    validationRule?: ValidationRule,
    heapEvent?: HeapCustomEvent,
    message?: string,
  ) {
    this.type = type;
    this.validationRule = validationRule;
    this.heapEvent = heapEvent;
    this.message = message;
  }
}

export { AlertType };
export default Alert;
